import { writable } from 'svelte/store';

const infoContext = writable("default");

const infoContextStore = {
    subscribe: infoContext.subscribe,
    set: infoContext.set,
    clear: () => {
        infoContext.set("default");

    }
}
export default infoContextStore;
